import { Box, Container, Stack, alpha } from "@mui/material";

import HeaderBalanceChip from "@/components/HeaderBalanceChip";
import HeaderClock from "@/components/HeaderClock";
import LanguageSelector from "@/components/LanguageSelector";
import NavbarBreadcrumbs from "@/components/NavbarBreadcrumbs";
import NotificationMenu from "@/components/NotificationMenu";

import ColorModeIcon from "./ColorModeIcon";

export default function Header() {
  return (
    // Sticky so the breadcrumbs and notifications stay in reach down a long table.
    <Box
      sx={(theme) => ({
        display: { xs: "none", md: "block" },
        position: "sticky",
        top: 0,
        zIndex: theme.zIndex.appBar,
        alignSelf: "stretch",
        mx: -3,
        px: 3,
        backgroundColor: alpha(theme.palette.background.default, 0.85),
        backdropFilter: "blur(8px)",
        borderBottom: "1px solid",
        borderColor: "divider",
      })}
    >
      <Container maxWidth={false} disableGutters sx={{ width: "100%", maxWidth: 2200 }}>
        <Stack
          direction="row"
          sx={{
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            py: 1,
          }}
          spacing={2}
        >
          <NavbarBreadcrumbs />
          <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
            <HeaderBalanceChip />
            <HeaderClock />
            <LanguageSelector />
            <NotificationMenu />
            <ColorModeIcon />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
